import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faHeadset } from "@fortawesome/free-solid-svg-icons";
import {
    PENDING_VERIFICATION_MESSAGE,
    PENDING_VERIFICATION_TITLE,
    SUPPORT_TELEGRAM_LABEL,
    SUPPORT_TELEGRAM_URL
} from "../../util/emissionPendingVerification";

// Sin botón de cerrar: el aviso permanece visible mientras la operación esté bloqueada.
const PendingVerificationAlert = ({ lock }) => (
    <div className="mb-5">
            <div className="alert alert-danger pending-ticket-alert pending-verification-alert mb-3" role="alert" aria-live="assertive">
            <div className="pending-ticket-alert-icon">
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
            <div className="pending-verification-alert-body">
                <h2 className="h5 pending-ticket-alert-title">{PENDING_VERIFICATION_TITLE}</h2>
                <p className="mb-2">{PENDING_VERIFICATION_MESSAGE}</p>
                {lock?.pnr ? (
                    <p className="mb-0 pending-ticket-alert-action">
                        PNR: <span>{lock.pnr}</span>
                        {/* {lock.orderId ? <span className="pending-verification-order"> · Orden: <span>{lock.orderId}</span></span> : null} */}
                    </p>
                ) : null}
            </div>
        </div>
        <div className="text-center pb-3">
            <a
                href={SUPPORT_TELEGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-md btn-primary py-2 px-4 mt-3"
            >
                <FontAwesomeIcon icon={faHeadset} className="mr-2" />
                {SUPPORT_TELEGRAM_LABEL}
            </a>
        </div>
    </div>
);

export default PendingVerificationAlert;
